export default __webpack_public_path__ + "static/media/unlock.33bad7ca.svg";